module.exports = __webpack_public_path__ + "static/mariya-georgieva-4575c40bfb8dec6713d2da51c4c4066e.jpg";